import { Injectable } from '@angular/core';
import {Router} from '@angular/router';
import { DeviceInfoService } from "../utils/device-info.service";
import { DataService } from './data.service';

declare let gtag: Function;
declare let fbq: Function;
declare let gtag_report_conversion_largo: Function;
declare let gtag_report_conversion_corto: Function;

@Injectable({
  providedIn: 'root'
})
export class ApiAnalyticsService {
  constructor(private router:Router,
              private device: DeviceInfoService,
              private data: DataService) 
  { 
  }
  email:string = '';
  phone:string = '';
  contextoLocal:string = '';

  gTag(event, category, event_label, value) : void {

    let responsive:string='';    
    if(this.device.getIsMobile()) {
      responsive='R';
    }
    
    gtag(
      'event', 
      responsive+event, {
        send_to: 'G-ZM42EM2TN8',
        event_category: category,
        event_label: event_label,
        value: responsive+event,
        email_user:this.email,
        phone_user:this.phone
      }
    );
      
  }

  gTagPage(url:string){
    let route=url;

    gtag('event', 'page_view', {
      'send_to': 'G-ZM42EM2TN8',
      'page_location': window.location.origin+'/abre-tu-cuenta'+route,
      'page_title': '/abre-tu-cuenta'+route
    });
  }

  fbQ(event) {
    fbq('track', event);
  }

  gTagPixelCorto(url) {
    if (window.location.origin === 'http://localhost:4200') {
      this.contextoLocal = 'http://localhost:4200/';
    } else {
      const getUrl = window.location;
      this.contextoLocal = getUrl.protocol + '//' + getUrl.host + getUrl.pathname.split('#')[0];
      this.contextoLocal = `${this.contextoLocal}`;
    }
    gtag_report_conversion_corto(`${this.contextoLocal}${url}`);
  }

  gTagPixelLargo(url) {
    if (window.location.origin === 'http://localhost:4200') {
      this.contextoLocal = 'http://localhost:4200/';
    } else {
      const getUrl = window.location;
      this.contextoLocal = getUrl.protocol + '//' + getUrl.host + getUrl.pathname.split('#')[0];
      this.contextoLocal = `${this.contextoLocal}`;
    }
    gtag_report_conversion_largo(`${this.contextoLocal}${url}`);
  }


}
